import { render, staticRenderFns } from "./userVirtualTheme.vue?vue&type=template&id=4041e3ef&"
import script from "./userVirtualTheme.vue?vue&type=script&lang=js&"
export * from "./userVirtualTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports